import React from "react";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import {  useNavigate } from "react-router-dom";
const NoScheduleAvailableModal =()=>{
    const navigate = useNavigate();
    return(
        <div className="noscheduleContainer">
        <div className="overlayModal"></div>
        <div
            className="closeIconContainer"
            onClick={() => navigate("/home")}
          >
            <CloseIcon />
          </div>
            <div className="contents">
            <h1>Currently, there is no available schedule !!</h1>
            </div>
      </div>
    )
}
export default NoScheduleAvailableModal;